import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { BoldSpanPipe } from './pipes/bold-span.pipe';
import { TimeReferencePipe } from './pipes/time-reference.pipe';
// import { LuxonDatePipe } from './pipes/luxon-date.pipe';
import { BackButtonComponent } from './shared-presenters/back-button/back-btn.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { InputPatternModule } from 'src/directives/input-pattern/input-pattern.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';

@NgModule({
	declarations: [
		BoldSpanPipe,
		TimeReferencePipe,
		// LuxonDatePipe,
		BackButtonComponent,
	],
	imports: [
		MatIconModule,
		TranslateModule,
		MatButtonModule,
		InputPatternModule,
		MatProgressBarModule,
		MatSidenavModule,
	],
	exports: [
		CommonModule,
		TranslateModule,
		RouterModule,

		BoldSpanPipe,
		TimeReferencePipe,
		// LuxonDatePipe,
		BackButtonComponent,
		MatButtonModule,
		MatIconModule,
		MatProgressBarModule,
		MatSidenavModule,
		InputPatternModule,
	],
})
export class BaseUiModule {}
